import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Brand from "@/components/Brand";
import { ArrowLeft } from "lucide-react";
import api, { extractErr } from "@/lib/api";

export default function MerchantResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords don't match"); return; }
    if (!token) { toast.error("Missing reset token"); return; }
    setLoading(true);
    try {
      await api.post("/auth/password/reset", { token, password });
      toast.success("Password updated. Please sign in.");
      nav("/login");
    } catch (err) {
      toast.error(extractErr(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/login" className="flex items-center gap-2 text-sm text-slate-400 hover:text-white mb-8" data-testid="reset-back">
          <ArrowLeft className="w-4 h-4" /> Back to sign in
        </Link>
        <div className="mb-6"><Brand variant="dark" size="md" /></div>
        <h1 className="font-display text-3xl font-bold">Set a new password</h1>
        <p className="text-slate-400 text-sm mt-1">Choose a strong password you haven't used before.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <Label className="text-slate-300">New password</Label>
            <Input required type="password" minLength={6} data-testid="reset-password" className="bg-slate-900 border-slate-700 text-white mt-1" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <div>
            <Label className="text-slate-300">Confirm password</Label>
            <Input required type="password" minLength={6} data-testid="reset-confirm" className="bg-slate-900 border-slate-700 text-white mt-1" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          </div>
          <Button type="submit" disabled={loading || !token} data-testid="reset-submit" className="w-full h-11 bg-orange-500 hover:bg-orange-600 text-slate-900 font-semibold rounded-full">
            {loading ? "Updating…" : "Update password"}
          </Button>
          {!token && <div className="text-sm text-red-400" data-testid="reset-notoken">Reset token is missing from URL. Please use the link from your email.</div>}
        </form>
      </div>
    </div>
  );
}
